module.exports = __webpack_public_path__ + "img/No-image.12b5c7d9.png";